/**
 * @param {(input: RequestInfo|URL, init?: RequestInit) => Promise<Response>} fetchImpl
 * @param {() => string} csrfTokenProvider
 */
export function createHintsApi(fetchImpl, csrfTokenProvider = getCsrfToken) {
    return {
        async markSeen(key, version) {
            const response = await fetchImpl('/xhr/hints/seen', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'X-CSRF-TOKEN': csrfTokenProvider(),
                },
                body: JSON.stringify({key, version}),
            });

            if (!response.ok) {
                throw new Error(`Не удалось сохранить подсказку: ${response.status}`);
            }

            return response.json();
        },
    };
}

function getCsrfToken() {
    if (window.csrf_token) {
        return window.csrf_token;
    }

    return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ?? '';
}

export const hintsApi = createHintsApi((...args) => globalThis.fetch(...args));
